import React from 'react';
import PropTypes from 'prop-types';
import { Container, Text } from './ButtonGoogleStyledComponents';
import googleG from '../../assets/images/google-g.svg';
export default function ButtonGoogle(_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled,
      children = _ref.children;
  return React.createElement(Container, {
    disabled: disabled,
    onClick: onClick
  }, React.createElement("img", {
    src: googleG,
    alt: ""
  }), React.createElement(Text, null, children));
}
ButtonGoogle.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.string
};
ButtonGoogle.defaultProps = {
  disabled: false,
  children: ''
};